exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card[data-v-12f008b7]{border:1px solid #939393!important;border-radius:0}.card-body[data-v-12f008b7]{padding:0}.card-header[data-v-12f008b7]{border:0;background-color:#fff;padding:0}button[data-v-12f008b7]{box-shadow:none!important;outline:none!important;font-weight:600}.form-check-label[data-v-12f008b7]{font-size:smaller}.l-bloc-radio[data-v-12f008b7]{background-color:#707070;margin-left:1rem;margin-right:1rem;color:#fff;font-size:11pt;font-family:Roboto,sans-serif;box-shadow:0 3px 5px 0 rgba(0,0,0,.75)}", ""]);

// exports
